import {NgModule} from "@angular/core";
import {AboutComponent} from "./about/about.component";
import {HomeComponent} from "./home/home.component";
import {RouterModule, Routes} from "@angular/router";
import {FeaturesComponent} from "./features/features.component";
import {PricingComponent} from "./pricing/pricing.component";
import {DiscoverComponent} from "./discover/discover.component";

const routes: Routes = [
  {path: 'about', component: AboutComponent, data: {title: 'About'}},
  {path: 'features', component: FeaturesComponent, data: {title: 'Features'}},
  {path: 'pricing', component: PricingComponent, data: {title: 'Pricing'}},
  {path: 'discover', component: DiscoverComponent, data: {title: 'Discover'}},
  {path: '', component: HomeComponent, pathMatch: 'full', data: {title: 'Home'}},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LandingRoutingModule {
}
